import { useState } from 'react'

import { Box, Flex, Text, useMediaQuery } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { useUpdateGeneralFeedbackMutation } from '@core/app/api/profileApi'
import { SuccessModal } from '@core/components/FeedbackModal/SuccessModal'
import { MainButton } from '@core/components/MainButton'
import { CustomModal } from '@core/components/Modal/Modal'
import { AutoResizeTextarea } from '@core/components/ResizeTextarea/ResizeTextarea'
import { useFeedbackModal } from '@core/utils/contexts/FeedbackModalContext'

export const FeedbackModal = () => {
    const { t } = useTranslation()
    const [isMobile] = useMediaQuery('(max-width: 768px)', { fallback: false })
    const [updateGeneralFeedback, { isLoading }] = useUpdateGeneralFeedbackMutation()
    const { isOpen, close } = useFeedbackModal()
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'Enter' && message.trim().length > 0 && !isLoading) {
            e.preventDefault()
            handleSubmit()
        }
    }

    const handleSubmit = () => {
        updateGeneralFeedback({ message: message.trim(), url: window.location.href })
            .unwrap()
            .then(() => {
                setMessage('')
                close()
                setIsSuccessModalOpen(true)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    return (
        <>
            <SuccessModal isOpen={isSuccessModalOpen} onClose={() => setIsSuccessModalOpen(false)} />
            <CustomModal
                size={isMobile ? 'sm' : '2xl'}
                removeBorders
                isOpen={isOpen}
                onClose={close}
                title={t('9477', 'Submit feedback') || 'Submit feedback'}
                body={
                    <Box px={{ base: '16px', md: '24px' }} py={{ base: '12px', md: '16px' }}>
                        <Text fontSize={'14px'} fontWeight={'medium'} color={'#4B4B4E'}>
                            {t(
                                '11231',
                                'Whether you have a missing feature in mind or just want to share your feedback, let us know so we can continue to improve.'
                            )}
                        </Text>
                        <Flex flexDirection={'column'} gap={'6px'} mt={'16px'}>
                            <Text fontSize={'12px'} fontWeight={'medium'} color={'#0C0C0D'}>
                                {t('7292', 'Suggestions')}
                            </Text>
                            <AutoResizeTextarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                onKeyDown={handleKeyDown}
                                fontSize={'sm'}
                                minRows={5}
                                // @ts-ignore
                                color={'#0C0C0D'}
                                maxLength={2000}
                                _placeholder={{ fontSize: 'sm', color: '#717175' }}
                                placeholder={
                                    t('11232', 'Share any thoughts or ideas you have') ||
                                    'Share any thoughts or ideas you have'
                                }
                            />
                        </Flex>
                    </Box>
                }
                footer={
                    <Flex justifyContent={'flex-end'} gap={'12px'}>
                        <MainButton
                            size={'sm'}
                            title={t('416', 'Cancel') || 'Cancel'}
                            view={'secondary'}
                            onClick={() => {
                                close()
                                setMessage('')
                            }}
                        />
                        <MainButton
                            size={'sm'}
                            title={t('7479', 'Submit') || 'Submit'}
                            view={'primary'}
                            isDisabled={message.trim().length === 0}
                            isLoading={isLoading}
                            onClick={handleSubmit}
                        />
                    </Flex>
                }
            />
        </>
    )
}
